<template>
    <section class="grid justify-center pt-2 px-4 md:px-8" v-show="financeDebts.length > 0">
        <div class="card overflow-auto">
            <DataTable 
                :value="financeDebts" 
                stripedRows 
                showGridlines 
                scrollable
                scrollHeight="800px"
                tableStyle="min-width: 30rem" 
                class="min-w-full deudas-pagar-table"
            >
                <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header">
                    <template #body="{data, field}">
                        <span>{{ data[field] }}</span>
                    </template>
                </Column>
            </DataTable>
        </div>
    </section>
</template>

<script>
import axiosInstance from '../axiosInstance';

export default {
    data() {
        return {
            financeDebts: [],
            columns: [{ field: "category", header: "Categoría" }]
        }
    },
    methods: {
        async fetchDebts() {
            this.$emit("update-loading", true);
            let data = {};
            
            try {
                const debts = axiosInstance.post("/api/finance_debts", {
                    token: localStorage.getItem('token')
                });
                data = await debts;
            } catch(error) {
                console.error("fetchDebts: There was an error!", error);
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Error',
                    detail: 'Hubo un problema al consultar los datos.', 
                    life: 5000, 
                    group: 'topr' 
                });
            } finally {
                this.$emit("update-loading", false);
            }

            return data;
        },
        
        fillTable() {
            this.fetchDebts().then((response) => {
                if(response.status == 200) {
                    const { departments, categories } = response.data;
                    
                    for(const dep of departments) {
                        this.columns.push({ field: dep.toLowerCase(), header: dep });
                    }

                    this.financeDebts = Object.values(categories).map((elem) => {
                        const newEntry = { category: elem.name };
                        for(let i = 1; i < this.columns.length; i++) {
                            newEntry[this.columns[i].field] = elem.data[i-1];
                        }
                        return newEntry;
                    });
                } else {
                    console.warn("fillTable: There was a problem with the request.", response);
                    this.$toast.add({ 
                        severity: 'warn', 
                        summary: 'Aviso',
                        detail: 'Hubo un problema con la solicitud. Vuelve a intentarlo.', 
                        life: 5000, 
                        group: 'topr' 
                    });
                }
            });
        }
    },
    mounted() {
        this.fillTable();
    }
}
</script>
<style scoped>
::v-deep(.p-datatable) {
    @apply rounded-lg overflow-hidden shadow;
}

::v-deep(.p-datatable thead tr th) {
    background-color: #0f1338 !important;
    color: white !important;
}

::v-deep(.p-datatable tbody tr td) {
    text-align: right;
}

::v-deep(.p-datatable tbody tr:not(:last-child):nth-child(odd) td) {
    background-color: #f3f4f6 !important;
    color: #111827 !important;
}

::v-deep(.p-datatable tbody tr:not(:last-child):nth-child(even) td) {
    background-color: #ffffff !important;
    color: #111827 !important;
}

::v-deep(.p-datatable tbody tr:not(:last-child) td:first-child) {
    /* background-color: #fecaca !important; */
    color: #ab0000 !important;
    font-weight: 600;
    text-align: left;
}

::v-deep(.p-datatable tbody tr:last-child td) {
    background-color: #0f1338 !important;
    color: white !important;
    font-weight: 600;
}

::v-deep(.p-datatable tbody tr:last-child td:first-child) {
    background-color: #0f1338 !important;
    color: white !important;
    font-weight: 600;
    text-align: left;
}
</style>

<style>
.dark .deudas-pagar-table thead tr th {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
}

.dark .deudas-pagar-table tbody tr:not(:last-child) td {
    color: white !important;
}

.dark .deudas-pagar-table tbody tr:not(:last-child):nth-child(odd) td {
    background-color: #18181b !important;
    color: white !important;
}

.dark .deudas-pagar-table tbody tr:not(:last-child):nth-child(even) td {
    background-color: #27272a !important;
    color: white !important;
}

.dark .deudas-pagar-table tbody tr:not(:last-child) td:first-child {
    /* background-color: #7f1d1d !important; */
    color: #ff7070 !important;
    font-weight: 600;
    text-align: left;
}

.dark .deudas-pagar-table tbody tr:last-child td {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
    font-weight: 600;
}

.dark .deudas-pagar-table tbody tr:last-child td:first-child {
    background-color: #D9D9D9 !important;
    color: #0f1338 !important;
    font-weight: 600;
    text-align: left;
}
</style>